export const FREQRENTALS_SIZE = 4;
export const QUICKRENT_URL = '/myaccount/quickrent?tabIndex=0';
